'use client'

import { useState } from 'react'

import * as TabsPrimitive from '@radix-ui/react-tabs'

import { TabsValueContext } from '~/components/component-library/Tabs/context'
import { type TabsRootProps } from '~/components/component-library/Tabs/types'

export const TabsRoot = ({
  ref,
  value,
  defaultValue,
  onValueChange,
  ...props
}: TabsRootProps) => {
  // Mirrors Radix's controlled/uncontrolled value so TabsSelect can read and
  // set it through TabsValueContext; Radix always gets a string so it never
  // switches between controlled and uncontrolled
  const [internalValue, setInternalValue] = useState(defaultValue ?? '')
  const isControlled = value !== undefined
  const current = isControlled ? value : internalValue

  const handleValueChange = (next: string) => {
    if (!isControlled) setInternalValue(next)
    onValueChange?.(next)
  }

  return (
    <TabsValueContext
      value={{ value: current, onValueChange: handleValueChange }}
    >
      <TabsPrimitive.Root
        ref={ref}
        value={current}
        onValueChange={handleValueChange}
        {...props}
      />
    </TabsValueContext>
  )
}
